import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  id: "website-banner-container",
  class: "updatebanner"
};
const _hoisted_2 = {
  class: "banner-container"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"updatebanner-icon\"><svg data-sly-test=\"${icon == &#39;notification&#39;}\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"17\" viewBox=\"0 0 16 17\" fill=\"none\"><path d=\"M7.2334 6.02148L7.58984 9.6543H8.36621L8.71777 6.02148V4.3418H7.2334V6.02148Z\" fill=\"white\"></path><path d=\"M7.29199 10.1279V11.5H8.66406V10.1279H7.29199Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 8.5C15 12.366 11.866 15.5 8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C11.866 1.5 15 4.63401 15 8.5ZM14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5Z\" fill=\"white\"></path></svg></div>", 1);
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "close-icon"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.99681 9.20391L11.1742 12.3813L11.8813 11.6742L8.70391 8.49681L11.8813 5.31941L11.1742 4.6123L7.99681 7.7897L4.81941 4.6123L4.1123 5.31941L7.2897 8.49681L4.1123 11.6742L4.81941 12.3813L7.99681 9.20391Z",
  fill: "white"
})], -1);
const _hoisted_7 = [_hoisted_6];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $options.hasResults && $data.showBanner || $data.showUpdatesBanner ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
    class: "title",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleTrackLink && $options.handleTrackLink(...args)),
    innerHTML: $options.getI18nMessage('new.website.updates')
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closeBanner && $options.closeBanner(...args)),
    class: "close-icon",
    "aria-label": "Close"
  }, _hoisted_7)])])])) : _createCommentVNode("", true);
}